import React, { Fragment } from "react";
import { Card, Col, Button } from 'react-bootstrap';
import '../../../../styles/diario.scss'
import moment from "moment";

const Partido = (props) => {

    moment.locale('pt');
    moment.updateLocale('pt', {
        months: [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
            "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ],
        weekdays: [
            "Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"
        ]
    });

    const url1 = `/transparencia${props.partid.arquivo}`;

    return (
        <Fragment>
            <Col>
                <Card className="card-list">
                    <Card.Header><a href={url1} target="_blank" rel="noreferrer"><h5>{moment(props.partid.dataCad).utc(false).format('dddd, DD [de] MMMM [de] YYYY')} - {props.partid.nomeAnexo}</h5></a></Card.Header>
                </Card>
            </Col>
        </Fragment >)
}

export default Partido;